<template>
  <div class="avatar-image">
    <Image
      v-if="user.avatar"
      :src="thumbnail"
      :alt="fullName"
      :title="fullName"
    />
    <span class="placeholder">
      {{ `${user.firstName[0]}${user.lastName[0]}` }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Image from '@components/utils/Image.vue';
import type { User } from '@/entities/Entities';
import { thumbnailUrl } from '@/utils/api';

interface Props {
  user: User
}
const props = defineProps<Props>();
const fullName = computed(() => `${props.user.firstName} ${props.user.lastName}`);
const thumbnail = computed(() => thumbnailUrl(props.user.avatar));
</script>

<style lang="scss" scoped>
.avatar-image {
  @apply rounded-full ring-1 ring-white;
  @apply overflow-hidden;
  @apply w-16 h-16;

  --tw-ring-color: rgb(255, 255, 255, 0.1);

  img {
    @apply w-full h-full;
    object-fit: cover;
    object-position: center;
  }
}

.placeholder {
  @apply w-full h-full;
  @apply flex justify-center items-center;
  @apply font-bold;
  @apply bg-background-light text-dark;
  @apply uppercase;
  font-size: px(24);
}
</style>
